import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import Dashboard from '../Templates/Dashboard';
import { ThemeContext } from './ThemeWrapper';
import {
    WelcomePage,
    DashboardPage,
    Error,
    NotFound,
    Form,
    Table,
    Parent,
    ManagerManagement,
    UserRegist,
    ManagerInfo,
    LogManagement,
    ConnectionIPManagement,
    UserInfoManagement,
    SiteSettings,
    PerplayUserManagement,
    PerplayUserInfo,
    PerplayUseLog,
    CampaignGames,
    RegistGameCampaign,
    GameInfoCampaign,
    RecommendedGame,
    NewCampaign,
    CampaignInfo,
    SpecialGame,
    NewSpecialCampaign,
    CampaignSpecialInfo,
    Banner,
    NewBanner,
    BannerInfo,
    WalletDashborad,
    Automation,
    XperPublish,
    RealTimeData,
    MessageManagement,
    NewMessage,
    PartnerManagement,
    RegistNewPartner,
    PartnerDetails,
    MaintenanceMain,
    MaintenanceRegist,
    MaintenanceInfo,
    ItemDB,
    NFT,
    GenerateItem,
    GameSessionLogMain,
    SpecialBoxLogMain,
    LoginLogMain,
    SessionLogMain,
    CategoryManagement,
    MiningEvent,
    MiningEventRegist,
    MiningEventInfo,
    FreeNFTEvent,
    FreeNFTEventRegist,
    FreeNFTEventInfo,
    InvitationEvent,
    InvitationEventRegist,
    InvitationEventInfo,
    StarterPackEvent,
    StarterPackEventRegist,
    StarterPackEventInfo,
    ServerStatusMonitoring,
    PowerChargeLogMain,
    LevelUpLogMain,
    BreedLogMain,
    EvolveLogMain,
    WalletTransactionLogMain,
    NFTTransactionLogMain,
    InventoryTransactionLogMain,
    NFTMain,
    WalletInfoMain,
    MarketTransactionLogMain,
    HolderLogMain,
    DrawItemMain,
    DrawItemRegist,
    DrawItemInfo,
    WhiteListApps,
    AppVersion,
    StringTableFetch,
    SummaryMain,
    FinanceMain,
    GemSocketLogMain,
    ResetStatsLogMain,
    BridgeWalletInfoMain,
    ItemBoxLogMain,
    RaffleMain,
    RaffleRegist,
    RaffleInfo,
    SafetyCodeLogMain,
    ItemShopMain,
    ItemShopProductRegist,
    ItemShopProductInfo,
    ItemShopLogMain,
    GoogleStorePurchaseLogList,
    GoogleStoreMain,
    GoogleStoreProductRegist,
    GoogleStoreProductInfo,
    Notice,
    NoticeUpdate,
    NoticeCreate,
    Event,
    EventCreate,
    EventUpdate,
    PilotEquipLogList,
    PilotSkillChangeLogList,
    PilotDisassembleLogList,
    PilotPromotionLogList
} from '../pageListAsync';
import MarketMain from '../Monitoring/Statistics/Market/MarketMain';
import UserMain from '../Monitoring/Statistics/User/UserMain';
import ItemMain from '../Monitoring/Statistics/Item/ItemMain';
import StatisticsNFTMain from '../Monitoring/Statistics/NFT/StatisticsNFTMain';
import TokenMain from '../Monitoring/Statistics/Token/TokenMain';
import NicknameTransactionLogMain from '../LogManagement/Perplay/NicknameTransaction/NicknameTransactionLogMain';
import GemSocketUpdateLogMain from '../LogManagement/Perplay/GemSocketUpdate/GemSocketUpdateLogMain';
import NFTRestoreLogMain from '../LogManagement/Perplay/NFTRestore/NFTRestoreLogMain';
import NFTRepairLogMain from '../LogManagement/Perplay/NFTRepair/NFTRepairLogMain';
import RentalLogMain from '../LogManagement/Perplay/Rental/RentalLogMain';
import DevImageUpload from '../AppManagement/DevImageUpload/DevImageUpload';
import DepositMain from '../walletManagement/Deposit/DepositMain';
import WalletSettlementMain from '../walletManagement/Settlement/WalletSettlementMain';
import GearMiningLogMain from '../LogManagement/Perplay/GearMining/GearMiningLogMain';
import NFTDisassembleLogMain from '../LogManagement/Perplay/NFTDisassemble/NFTDisassembleLogMain';
import UserItemManageMain from '../AppManagement/FixAppData/UserItemManage/UserItemManageMain';
import InAppIcons from '../AppManagement/InAppIcons/InAppIcons';
import FileUpload from '../AppManagement/FileUpload/FileUpload';
import PartnerManageMain from '../EventManagement/NewUserEvent/PartnerManage/PartnerManageMain';
import partnerDetails from '../EventManagement/NewUserEvent/PartnerManage/partnerDetails';
import BasicMissionMain from '../AppManagement/Basic/Mission/BasicMissionMain';
import basicMissionRegist from '../AppManagement/Basic/Mission/basicMissionRegist';
import basicMissionInfo from '../AppManagement/Basic/Mission/basicMissionInfo';
import BasicMissionLogMain from '../AppManagement/Basic/Mission/BasicMissionLogMain';
import BasicReferralMain from '../AppManagement/Basic/Referral/BasicReferralMain';
import BasicReferralAccountInfo from '../AppManagement/Basic/Referral/BasicReferralAccountInfo';
import WalletConnectionLogMain from '../LogManagement/User/WalletConnetion/WalletConnectionLogMain';
import FileBasedPostMain from '../UserManagement/FileBasedPost/FileBasedPostMain';
import InAppRankSystemMain from '../AppManagement/FixAppData/InAppRankSystem/InAppRankSystemMain';
import InAppRankSystemUpdate from '../AppManagement/FixAppData/InAppRankSystem/InAppRankSystemUpdate';
import StoredPowerLogMain from '../LogManagement/Perplay/StoredPower/StoredPowerLogMain';
import BasicReferralPointLog from '../AppManagement/Basic/Referral/BasicReferralPointLog';
import BasicReferralRewardLog from '../AppManagement/Basic/Referral/BasicReferralRewardLog';
import TransactionAttemptLogMain from '../LogManagement/User/TransactionAttempt/TransactionAttemptLogMain';

function Application(props) {
  const { history } = props;
  const changeMode = useContext(ThemeContext);

  return (
    <Dashboard history={history} changeMode={changeMode}>
      <Switch>
        {/* Home */}
        <Route exact path="/admin" component={WelcomePage} />

        <Route path="/app/pages/dashboard" component={DashboardPage} />
        <Route path="/app/pages/form" component={Form} />
        <Route path="/app/pages/table" component={Table} />
        <Route path="/app/pages/page-list" component={Parent} />
        <Route path="/app/pages/pages/not-found" component={NotFound} />
        <Route path="/app/pages/pages/error" component={Error} />

        {/* 월렛 관리 */}
        <Route path={'/admin/wallet/dashboard'} component={WalletDashborad} />
        <Route path={'/admin/wallet/automation'} component={Automation} />
        <Route
          path={'/admin/wallet/tokenNFT/xperPublish'}
          component={XperPublish}
        />
        <Route
          path={'/admin/wallet/serverStatus'}
          component={ServerStatusMonitoring}
        />
        <Route path={'/admin/wallet/deposit'} component={DepositMain} />
        <Route
          path={'/admin/wallet/settlement'}
          component={WalletSettlementMain}
        />

        {/* 앱 관리 */}
        <Route
          exact
          path="/admin/app/fixAppData/realTime"
          component={RealTimeData}
        />
        <Route exact path="/admin/app/fixAppData/itemDB" component={ItemDB} />
        <Route
          exact
          path="/admin/app/fixAppData/userItemManage"
          component={UserItemManageMain}
        />
        <Route exact path="/admin/app/fixAppData/nft" component={NFT} />
        <Route
          path="/admin/app/fixAppData/nft/generate"
          component={GenerateItem}
        />
        <Route
          exact
          path="/admin/app/fixAppData/inAppRankSystem"
          component={InAppRankSystemMain}
        />
        <Route
          exact
          path={"/admin/app/fixAppData/inAppRankSystem/update"}
          component={InAppRankSystemUpdate}
        />
        <Route
          exact
          path="/admin/app/fixedAppData/itemShop"
          component={ItemShopMain}
        />
        <Route
          exact
          path="/admin/app/fixedAppData/itemShop/productInfo"
          component={ItemShopProductInfo}
        />
        <Route
          exact
          path="/admin/app/fixedAppData/itemShop/newProduct"
          component={ItemShopProductRegist}
        />

        <Route
          exact
          path={'/admin/app/fixedAppData/googleStore'}
          component={GoogleStoreMain}
        />

        <Route
          exact
          path={'/admin/app/fixedAppData/googleStore/newProduct'}
          component={GoogleStoreProductRegist}
        />

        <Route
          exact
          path={'/admin/app/fixedAppData/googleStore/productInfo'}
          component={GoogleStoreProductInfo}
        />

        <Route
          exact
          path="/admin/app/game/campaign"
          component={CampaignGames}
        />
        <Route
          path="/admin/app/game/campaign/gameInfoCampaign"
          component={GameInfoCampaign}
        />
        <Route
          path="/admin/app/game/campaign/registGameCampaign"
          component={RegistGameCampaign}
        />

        <Route
          exact
          path="/admin/app/campaign/recommended"
          component={RecommendedGame}
        />
        <Route
          path="/admin/app/campaign/recommended/newCampaign"
          component={NewCampaign}
        />
        <Route
          path="/admin/app/campaign/recommended/campaignInfo"
          component={CampaignInfo}
        />

        <Route
          exact
          path="/admin/app/campaign/special"
          component={SpecialGame}
        />
        <Route
          exact
          path="/admin/app/campaign/special/newCampaign"
          component={NewSpecialCampaign}
        />
        <Route
          exact
          path="/admin/app/campaign/special/campaignInfo"
          component={CampaignSpecialInfo}
        />

        <Route
          exact
          path="/admin/app/maintenance/schedule"
          component={MaintenanceMain}
        />
        <Route
          path="/admin/app/maintenance/schedule/regist"
          component={MaintenanceRegist}
        />
        <Route
          path="/admin/app/maintenance/schedule/info"
          component={MaintenanceInfo}
        />

        <Route exact path="/admin/app/whitelist" component={WhiteListApps} />
        <Route exact path="/admin/app/version" component={AppVersion} />
        <Route
          exact
          path="/admin/app/fetch/string"
          component={StringTableFetch}
        />

        {/* 개발자용 이미지 업로드 페이지 -> 파일 업로드 페이지로 통합 */}
        {/*<Route*/}
        {/*  exact*/}
        {/*  path="/admin/app/devImageUpload"*/}
        {/*  component={DevImageUpload}*/}
        {/*/>*/}

        {/*/!* 인앱 아이콘 관리 페이지 -> 파일 업로드 페이지로 통합 */}
        {/*<Route exact path="/admin/app/inAppIcons" component={InAppIcons} />*/}

        {/* 앱 설정 파일 관리 페이지 -> 파일 관리 페이지 */}
        <Route exact path="/admin/app/fileUpload" component={FileUpload} />

        {/* Basic 미션 페이지 */}
        <Route
          exact
          path="/admin/app/basic/mission/"
          component={BasicMissionMain}
        />

        <Route
          path="/admin/app/basic/mission/basicMissionRegist"
          component={basicMissionRegist}
        />

        <Route
          path="/admin/app/basic/mission/basicMissionInfo"
          component={basicMissionInfo}
        />

        <Route
          exact
          path="/admin/app/basic/mission/basicMissionRewardLog"
          component={BasicMissionLogMain}
        />

        {/* Basic Referral 페이지 */}
        <Route
          exact
          path="/admin/app/basic/referral/"
          component={BasicReferralMain}
        />

        <Route
          exact
          path="/admin/app/basic/referral/invitedUserList"
          component={BasicReferralAccountInfo}
        />

        <Route
          exact
          path="/admin/app/basic/referral/pointLog"
          component={BasicReferralPointLog}
        />

        <Route
          exact
          path="/admin/app/basic/referral/gradeRewardLog"
          component={BasicReferralRewardLog}
        />

        {/* 이벤트 관리 */}
        <Route exact path="/admin/event/banner" component={Banner} />
        <Route path="/admin/event/banner/newBanner" component={NewBanner} />
        <Route path="/admin/event/banner/bannerInfo" component={BannerInfo} />

        {/* 공지사항 관리 */}
        <Route exact path={"/admin/event/notice"} component={Notice} />
        <Route path={"/admin/event/notice/create"} component={NoticeCreate}/>
       <Route path={"/admin/event/notice/update"} component={NoticeUpdate} />

        {/*  이벤트 관리 */}
          <Route exact path={"/admin/event/popup"} component={Event}/>
          <Route path={"/admin/event/popup/create"} component={EventCreate}/>
          <Route path={"/admin/event/popup/update"} component={EventUpdate}/>

        <Route
          exact
          path="/admin/event/balance/mining"
          component={MiningEvent}
        />
        <Route
          path="/admin/event/balance/regist"
          component={MiningEventRegist}
        />
        <Route path="/admin/event/balance/info" component={MiningEventInfo} />

        <Route
          exact
          path="/admin/event/newUser/freeNFT"
          component={FreeNFTEvent}
        />
        <Route
          path="/admin/event/newUser/freeNFT/regist"
          component={FreeNFTEventRegist}
        />
        <Route
          path="/admin/event/newUser/freeNFT/info"
          component={FreeNFTEventInfo}
        />

        <Route
          exact
          path="/admin/event/newUser/invitation"
          component={InvitationEvent}
        />
        <Route
          path="/admin/event/newUser/invitation/regist"
          component={InvitationEventRegist}
        />
        <Route
          path="/admin/event/newUser/invitation/info"
          component={InvitationEventInfo}
        />

        {/* 파트너사 관리 */}
        <Route
          exact
          path="/admin/event/newUser/partnerManage"
          component={PartnerManageMain}
        />

        <Route
          path="/admin/event/newUser/partnerManage/Details"
          component={partnerDetails}
        />

        <Route
          exact
          path="/admin/event/userActivity/starterPack"
          component={StarterPackEvent}
        />
        <Route
          path="/admin/event/userActivity/starterPack/regist"
          component={StarterPackEventRegist}
        />
        <Route
          path="/admin/event/userActivity/starterPack/info"
          component={StarterPackEventInfo}
        />
        <Route
          exact
          path="/admin/event/userActivity/drawitem"
          component={DrawItemMain}
        />
        <Route
          exact
          path="/admin/event/userActivity/drawitem/regist"
          component={DrawItemRegist}
        />
        <Route
          exact
          path="/admin/event/userActivity/drawitem/info"
          component={DrawItemInfo}
        />

        <Route
          exact
          path="/admin/event/userActivity/raffle"
          component={RaffleMain}
        />
        <Route
          exact
          path="/admin/event/userActivity/raffle/regist"
          component={RaffleRegist}
        />
        <Route
          exact
          path="/admin/event/userActivity/raffle/info"
          component={RaffleInfo}
        />

        {/* 유저 관리 */}
        <Route
          exact
          path="/admin/user/perplayUser/userInfo"
          component={PerplayUserManagement}
        />
        <Route
          path="/admin/user/perplayUser/userInfo/perplayUserInfo"
          component={PerplayUserInfo}
        />

        <Route
          exact
          path="/admin/user/perplayUser/useLog"
          component={PerplayUseLog}
        />

        <Route exact path="/admin/user/message" component={MessageManagement} />
        <Route path="/admin/user/message/newMessage" component={NewMessage} />

        <Route
          exact
          path="/admin/user/fileBasedPost"
          component={FileBasedPostMain}
        />

        {/* 로그 관리 */}
        <Route exact path="/admin/log/user/login" component={LoginLogMain} />
        <Route
          exact
          path="/admin/log/user/session"
          component={SessionLogMain}
        />
        <Route
          exact
          path="/admin/log/user/walletConnection"
          component={WalletConnectionLogMain}
        />
        <Route
          exact
          path="/admin/log/user/transactionAttempt"
          component={TransactionAttemptLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/gamesession"
          component={GameSessionLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/accountHolderChange"
          component={HolderLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/specialbox"
          component={SpecialBoxLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/powerCharge"
          component={PowerChargeLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/levelUp"
          component={LevelUpLogMain}
        />
        <Route exact path="/admin/log/perplay/breed" component={BreedLogMain} />
        <Route
          exact
          path="/admin/log/perplay/evolve"
          component={EvolveLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/walletTransaction"
          component={WalletTransactionLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/nftTransaction"
          component={NFTTransactionLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/inventoryTransaction"
          component={InventoryTransactionLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/marketTransaction"
          component={MarketTransactionLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/gemSocketReset"
          component={GemSocketLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/statReset"
          component={ResetStatsLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/nickname"
          component={NicknameTransactionLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/gemSocketUpdate"
          component={GemSocketUpdateLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/nftRestore"
          component={NFTRestoreLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/nftRepair"
          component={NFTRepairLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/nftRental"
          component={RentalLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/nftGearMining"
          component={GearMiningLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/nftDisassembleLog"
          component={NFTDisassembleLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/storedPower"
          component={StoredPowerLogMain}
        />
        <Route
          exact
          path="/admin/log/perplay/itemBox"
          component={ItemBoxLogMain}
        />
        {/*SafetyCodeLogMain*/}
        <Route
          exact
          path="/admin/log/perplay/safetyCode"
          component={SafetyCodeLogMain}
        />

        <Route
          exact
          path="/admin/log/perplay/itemShop"
          component={ItemShopLogMain}
        />
        <Route
          exact
          path={'/admin/log/perplay/googleStore'}
          component={GoogleStorePurchaseLogList}
        />
        <Route
          exact
          path={'/admin/log/perplay/pilotEquip'}
          component={PilotEquipLogList}
        />
        <Route
          exact
          path={'/admin/log/perplay/pilotSkillChange'}
          component={PilotSkillChangeLogList}
        />
        <Route
          exact
          path={'/admin/log/perplay/pilotDisassemble'}
          component={PilotDisassembleLogList}
        />
        <Route
          exact
          path={'/admin/log/perplay/pilotPromotion'}
          component={PilotPromotionLogList}
        />


          {/* 모니터링 */}
        {/* 정보 조회 */}
        <Route
          exact
          path="/admin/monitoring/information/NFT"
          component={NFTMain}
        />
        <Route
          exact
          path="/admin/monitoring/information/Wallet"
          component={WalletInfoMain}
        />

        <Route
          exact
          path="/admin/monitoring/information/Wallet/BridgeWallet"
          component={BridgeWalletInfoMain}
        />

        {/* 통계 */}
        <Route
          exact
          path="/admin/monitoring/statistics/summary"
          component={SummaryMain}
        />
        <Route
          exact
          path="/admin/monitoring/statistics/finance"
          component={FinanceMain}
        />
        <Route
          exact
          path="/admin/monitoring/statistics/token"
          component={TokenMain}
        />
        <Route
          exact
          path="/admin/monitoring/statistics/market"
          component={MarketMain}
        />
        <Route
          exact
          path="/admin/monitoring/statistics/nft"
          component={StatisticsNFTMain}
        />
        <Route
          exact
          path="/admin/monitoring/statistics/item"
          component={ItemMain}
        />
        <Route
          exact
          path="/admin/monitoring/statistics/user"
          component={UserMain}
        />

        {/* 백오피스 관리 */}
        <Route path="/admin/backoffice/manager" component={ManagerManagement} />
        <Route path="/admin/backoffice/managerInfo" component={ManagerInfo} />
        <Route path="/admin/backoffice/userRegist" component={UserRegist} />

        <Route
          exact
          path="/admin/backoffice/partner"
          component={PartnerManagement}
        />
        <Route
          path="/admin/backoffice/partner/regist"
          component={RegistNewPartner}
        />
        <Route
          path="/admin/backoffice/partner/details/:accountNo"
          component={PartnerDetails}
        />

        <Route path="/admin/backoffice/log" component={LogManagement} />

        <Route
          path="/admin/backoffice/connectIP"
          component={ConnectionIPManagement}
        />

        <Route
          path="/admin/backoffice/category"
          component={CategoryManagement}
        />

        {/* 환경 설정 */}
        <Route path="/admin/setting/userInfo" component={UserInfoManagement} />
        <Route path="/admin/setting/site" component={SiteSettings} />

        <Route component={NotFound} />
      </Switch>
    </Dashboard>
  );
}

Application.propTypes = {
  history: PropTypes.object.isRequired,
};

export default Application;
